import { render, staticRenderFns } from "./MultipleRoTransfer.vue?vue&type=template&id=15b08a54"
import script from "./MultipleRoTransfer.vue?vue&type=script&lang=js"
export * from "./MultipleRoTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports